<template>
  <div>
    <v-autocomplete
      :items="items"
      item-text="text"
      item-value="id"
      v-model="contextModel"
      :label="$t('components.ajaxBookingHotelSelect.label')"
      append-icon="local_hotel"
      :error-messages="validationMessage"
      :menu-props="{ value: false }"
      @focus="openDialog"
    >
      <template slot="selection" slot-scope="data">
        <v-chip small :selected="data.selected" :key="JSON.stringify(data.item)" @click="openDialog">
          {{ data.item.text }}
        </v-chip>
      </template>
    </v-autocomplete>
    <v-dialog v-model="dialog" persistent max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("components.ajaxBookingHotelSelect.hotelBookingList") }}</span>
          <v-spacer />
          <v-col cols="6">
            <v-text-field v-model="search" append-icon="search" :label="$t('global.search')" single-line hide-details />
          </v-col>
        </v-card-title>

        <booking-hotel-data-table :search="search">
          <div slot="action-column" slot-scope="item">
            <v-btn icon class="ma-0" disabled v-if="isWNBUser" :title="$t('components.ajaxBookingHotelSelect.showBookingDetails')">
              <v-icon>remove_red_eye</v-icon>
            </v-btn>
            <!--                                <v-btn icon class="ma-0" v-on:click="assignBooking(props.item)"
                                                                   title="Przypnij rezerwację (koszty)">
                                                                <v-icon>play_for_work</v-icon>
                                                            </v-btn>
                                                            -->
            <v-btn
              v-on:click="importHotel(item.booking)"
              icon
              class="ma-0"
              :disabled="$store.getters['Ajax/loading']"
              :title="$t('components.ajaxBookingHotelSelect.importBooking')"
            >
              <v-icon>mdi-hotel</v-icon>
            </v-btn>
          </div>
        </booking-hotel-data-table>

        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click.native="dialog = false">{{ $t("global.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BookingHotelDataTable from "../Booking/BookingHotelDataTable.vue";

export default {
  name: "AjaxBookingHotelSelect",
  components: { BookingHotelDataTable },
  props: {
    readonly: {
      required: false,
      default: false
    },
    validationMessage: {
      type: Array,
      default: function() {
        return [];
      }
    },
    model: {
      required: true
    },
    fileId: {
      required: false,
      default: null
    },
    bookingText: {
      required: false,
      default: null
    }
  },
  data: () => ({
    newId: -1,
    uploadButton: true,
    dialog: false,
    validationError: false,
    //validationMessage: [],
    //items: [],
    search: "",
    uploadedFile: null,
    //loading: false,

    loading: false
  }),
  watch: {
    selectModel(val) {
      this.onChange(val);
    }
  },
  computed: {
    items() {
      if (this.model != null) {
        return [{ id: this.model, text: this.bookingText }];
      }
      return [];
    },
    contextModel: {
      set: function(value) {
        this.$emit("update:model", value);
      },
      get: function() {
        return this.model;
      }
    },
    isWNBUser() {
      return this.$store.getters["isWnbUser"];
    },
    contextFileId: {
      get() {
        return this.fileId;
      },
      set(value) {
        this.$emit("update:fileId", value);
      }
    }
  },
  methods: {
    openDialog() {
      if (this.readonly !== true) {
        this.dialog = true;
      }
    },
    assignBooking(item) {
      this.$emit("update:model", item.id);
      this.$emit("update:bookingText", item.hotelAttributes.city + ": " + item.hotelAttributes.vendor);
      let self = this;
      this.axios.get("delegation/get-booking-file?bookingId=" + item.id).then(resp => {
        self.$emit("fileRemoved", { id: self.contextFileId });
        this.contextFileId = resp.data.file_id;
        const newItem = {
          id: resp.data.file_id,
          itemName: resp.data.file_name,
          status: this.$t("global.generatedServerSide"),
          fileSize: 0,
          uploadedSize: 0
        };
        self.$emit("fileUploaded", newItem);
      });
      this.dialog = false;
    },
    importHotel(item) {
      this.$emit("importAccommodationData", item);
      this.assignBooking(item);
    }
  },
  created() {},
  beforeDestroy() {
    this.$emit("update:model", null);
    this.$emit("update:bookingText", null);
    this.$emit("fileRemoved", { id: this.contextFileId });
  }
};
</script>

<style scoped>
.chip--small {
  height: 22px;
}
</style>
